import React from "react";
import { Link, useLocation } from "react-router-dom";
import "./blogNavbar.css";

function BlogNavbar() {
  const location = useLocation();

  const estaNoArtigo =
    location.pathname.startsWith("/blog/") &&
    location.pathname !== "/blog";

  return (
    <nav className="blog-navbar">
      <div className="container blog-navbar-content">

        {/* LOGO */}
        <Link to="/" className="blog-navbar-logo">
          <img
            src="/Images/logo2.png"
            alt="TCC Engenharia Civil"
            height="48"
          />
        </Link>

        {/* LINK DINÂMICO */}
        {estaNoArtigo ? (
          <Link to="/blog" className="blog-navbar-link">
            ← Voltar para o blog
          </Link>
        ) : (
          <Link to="/" className="blog-navbar-link">
            ← Voltar para o site
          </Link>
        )}

      </div>
    </nav>
  );
}

export default BlogNavbar;
